var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignatureIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.2007 11.9998 0.2007 11.9998 1 0 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0.0701 3.2468 0.0701 3.2468 3.3131 0 3.3131"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-Consumer-Template",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_-Blue_DefaultSE",
    transform: "translate(-66.000000, -480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(66.000000, 480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 9.812600)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0002,0.4022 C0.0228,0.4022 0.0468,0.4012 0.0698,0.4012 L11.9108,0.4012 L11.9998,0.4012 L11.9998,0.9962 L11.9158,0.9962 L0.0878,0.9962 C0.0588,0.9962 0.0288,0.9992 -0.0002,1.0002 L-0.0002,0.4022 Z",
    id: "Fill-1",
    fill: "#231F20",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 5.812600)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0002,0.6971 C0.0268,0.6731 0.0558,0.6491 0.0818,0.6231 C0.2638,0.4411 0.4458,0.2581 0.6268,0.0761 C0.9568,0.4081 1.2838,0.7371 1.6108,1.0651 C1.9518,0.7241 2.2808,0.3951 2.6058,0.0701 C2.8248,0.2881 3.0338,0.4961 3.2468,0.7091 C2.9218,1.0331 2.5918,1.3621 2.2588,1.6931 C2.5938,2.0271 2.9208,2.3541 3.2448,2.6771 C3.0328,2.8901 2.8248,3.0981 2.6138,3.3091 C2.2908,2.9851 1.9648,2.6581 1.6398,2.3311 C1.3058,2.6651 0.9788,2.9921 0.6578,3.3131 C0.4398,3.0951 0.2308,2.8851 0.0208,2.6751 C0.3378,2.3571 0.6658,2.0301 0.9948,1.7011 C0.9798,1.6841 0.9708,1.6711 0.9598,1.6611 C0.6508,1.3511 0.3418,1.0421 0.0318,0.7331 C0.0228,0.7231 0.0108,0.7171 -0.0002,0.7091 L-0.0002,0.6971 Z",
    id: "Fill-4",
    fill: "#231F20",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.5276,6.3774 C6.5926,6.3484 6.6486,6.3244 6.7026,6.2994 C7.4126,5.9654 8.0206,5.5024 8.4896,4.8684 C8.8846,4.3344 9.1346,3.7364 9.2886,3.0924 C9.3726,2.7404 9.4176,2.3864 9.3576,2.0254 C9.3076,1.7214 9.1996,1.4424 8.9946,1.2074 C8.7066,0.8764 8.3506,0.8154 7.9716,1.0344 C7.6886,1.1974 7.4846,1.4404 7.3146,1.7134 C7.0246,2.1754 6.8546,2.6844 6.7286,3.2104 C6.6156,3.6824 6.5446,4.1604 6.5036,4.6434 C6.4656,5.0884 6.4186,5.5344 6.4696,5.9814 C6.4856,6.1104 6.5076,6.2394 6.5276,6.3774 M6.8206,7.1654 C6.9556,7.4064 7.1206,7.6114 7.3366,7.7734 C7.6576,8.0154 8.0246,8.1124 8.4236,8.1104 C8.7536,8.1094 9.0556,8.0094 9.3476,7.8644 C9.5696,7.7544 9.7866,7.6324 10.0296,7.5744 C10.3456,7.4994 10.6666,7.4654 10.9856,7.5544 C11.5426,7.7094 11.9176,8.2444 11.8776,8.8194 C11.8646,9.0054 11.8646,9.0054 11.6766,9.0054 L11.0326,9.0054 L10.9686,9.0054 C10.9636,8.9134 10.9616,8.8264 10.9516,8.7394 C10.9466,8.6904 10.9326,8.6394 10.9156,8.5924 C10.8666,8.4654 10.7766,8.4084 10.6396,8.4064 C10.2966,8.4034 9.9766,8.4914 9.6766,8.6574 C9.4716,8.7714 9.2636,8.8774 9.0346,8.9354 C8.5926,9.0454 8.1556,9.0214 7.7226,8.8904 C6.9536,8.6584 6.3756,8.1934 5.9966,7.4824 C5.9916,7.4724 5.9856,7.4624 5.9766,7.4474 C5.2026,7.6574 4.4156,7.7824 3.6076,7.8074 L3.6076,6.9124 C3.6286,6.9124 3.6506,6.9124 3.6736,6.9124 C4.3376,6.9264 4.9896,6.8434 5.6326,6.6814 C5.6826,6.6694 5.6916,6.6524 5.6796,6.6024 C5.5796,6.1634 5.5506,5.7184 5.5566,5.2704 C5.5676,4.3914 5.6726,3.5254 5.9346,2.6844 C6.1246,2.0754 6.3886,1.5044 6.7806,0.9984 C7.0286,0.6784 7.3136,0.3964 7.6756,0.2104 C8.3076,-0.1146 8.9176,-0.0626 9.4836,0.3644 C9.7756,0.5844 9.9376,0.9004 10.0466,1.2444 C10.1756,1.6564 10.2066,2.0824 10.1996,2.5114 C10.1896,3.2304 10.0606,3.9234 9.7606,4.5804 C9.4136,5.3394 8.8806,5.9434 8.2026,6.4254 C7.7976,6.7134 7.3596,6.9444 6.8986,7.1324 C6.8756,7.1414 6.8526,7.1514 6.8206,7.1654",
    id: "Fill-7",
    fill: "#231F20"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureIcon);
export default __webpack_public_path__ + "static/media/signature-icon.15f2e270d65ec254a282660c4d61e6f5.svg";
export { ForwardRef as ReactComponent };